import { Category } from '@mui/icons-material';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { Observer, observer } from 'mobx-react';
import React from 'react';
import '../css/categoriasMinuta.css';
import Modal from '../misc/Modal';
import TransferList from '../misc/TransferList';
import { CategoriaMinuta, CategoriaMinuta as ICategoriaMinuta, Minuta, Processo } from '../modelo';
import CategoriaMinutaService from '../services/CategoriaMinutaService';
import CategoriaService from '../services/CategoriaService';
import MovimentoService from '../services/MovimentoService';
import MovimentoCNJStore from '../store/MovimentoCNJStore';
import ModalMovimentosCategoria from './ModalMovimentosCategoria';

interface IPropsCategoriasMinuta {
    minutasEmLote?: boolean;
    iconeEModal?: boolean;
    callbackSelecinarCategorias?: (itensSelecionados) => any;
    categoriasSelecionadas?: ICategoriaMinuta[];
    processo?: Processo;
    minuta?: Minuta;
}

interface IStateCategoriasMinuta {
    modalCategoriaAberto: boolean;
    carregandoModalCategorias: boolean;
    versaoConteudoModal: number;
}


class CategoriasMinuta extends React.Component<IPropsCategoriasMinuta, IStateCategoriasMinuta> {
    categorias: ICategoriaMinuta[] = [];
    categoriaEmEdicao: ICategoriaMinuta;
    categoriasSelecionadas: ICategoriaMinuta[] = [];
    carregouCategorias: boolean = false;
    modalComplementosAberto: boolean = false;
    abriuModalCategoriaEmMs: number = 0;

    constructor(props: IPropsCategoriasMinuta) {
        super(props);

        makeObservable(this, {
            categorias: observable,
            categoriaEmEdicao: observable,
            categoriasSelecionadas: observable,
            carregouCategorias: observable,
            modalComplementosAberto: observable,
            abriuModalCategoriaEmMs: observable,
            abrirModalComplementoCategoria: action,
            fecharModalComplementos: action,
            abrirModalCategoria: action,
            fecharModalCategoria: action,

});

        this.state = {
            modalCategoriaAberto: false,
            carregandoModalCategorias: false,
            versaoConteudoModal: 0
        };
    }

    get idProcesso() {
        return this.props.processo?.identificadorProcesso;
    }

    get tipoMinuta() {
        return this.props.minuta?.tipo;
    }

    iniciarCategorias = async () => {
        if (this.categorias.length === 0) {
            const categoriasDoGabinete = await CategoriaService.carregarCategorias(this.props.processo as Processo);
            const categoriasDaMinuta = await CategoriaService.carregarCategoriasDaMinutaMovimentosComplementos(
                this.props.processo as Processo,
                this.props.minuta
            );

            const categoriasComMovimento = categoriasDaMinuta.filter(categoria => {
                if (categoria.codigoMovimentoCnj) {
                    return categoria.codigoMovimentoCnj?.toString().includes(this.props.processo.origemProcesso?.id)
                }
                return true;
            });

            await Promise.all(categoriasComMovimento.map(async (categoria) => {
                if (categoria.codigoMovimentoCnj) {
                    try {
                        const mov = await CategoriaService.carregarMovimentoCategoria(categoria, !this.props.minutasEmLote ? (this.props.processo as Processo) : undefined);
                        runInAction(() => {
                            categoria.movimentoCNJ = mov;
                        });
                    } catch (erro) {
                        console.error('Erro ao carregar movimento da categoria', erro);
                    }
                }
                return categoria;
            }));

            runInAction(() => {
                this.categorias = categoriasDoGabinete;
                this.carregouCategorias = true;
            });
        }
    }

    retiraCatDaMinuta = (categoriaDoGabinete) => {
        return !this.props.minuta.categorias.find(catMin => catMin.numero === categoriaDoGabinete.numero);
    }

    componentDidMount() {
        // Precisa ser síncrono (não pode retornar Promise): em React 19 + mobx-react 9,
        // um componentDidMount `async` quebra permanentemente a reatividade do observer().
        (async () => {
            if (this.props.minutasEmLote) {
                this.categoriasSelecionadas = this.props.categoriasSelecionadas;
                const categorias = await CategoriaService.carregarCategorias(this.props.processo as Processo);
                runInAction(() => {
                    this.categorias = categorias;
                });
            }
        })();
    };

    selecionarCategorias = (selecionados: CategoriaMinuta[], _listaOriginal) => {
        Promise.all(selecionados.filter(cat => !this.categoriasSelecionadas.find(catSelect => catSelect.codigoMovimentoCnj === cat.codigoMovimentoCnj))
            .map(async (categoria) => {
                const mov = await CategoriaService.carregarMovimentoCategoria(categoria, !this.props.minutasEmLote ? (this.props.processo as Processo) : undefined);
                runInAction(() => {
                    categoria.movimentoCNJ = mov;
                });
                return categoria;
            })).then((result) => {
                runInAction(() => {
                    this.categoriasSelecionadas = selecionados;
                    this.props.callbackSelecinarCategorias(result);
                });
            });
    }

    abrirModalComplementoCategoria = (categoria) => {
        this.modalComplementosAberto = true;
        this.categoriaEmEdicao = categoria;
    };

    fecharModalComplementos = () => {
        this.modalComplementosAberto = false;
    };

    esperarCarregamentoECarregarCatDeMinuta = async () => {
        const categorias = await CategoriaService.carregarCategoriasDaMinutaMovimentosComplementos(this.props.processo as Processo, this.props.minuta);
        runInAction(() => {
            this.props.minuta.categorias = categorias;
            this.categoriasSelecionadas = categorias;
        });

    }

    abrirModalCategoria = (ev?: React.MouseEvent) => {
        ev?.preventDefault?.();
        ev?.stopPropagation?.();
        ev?.nativeEvent?.stopImmediatePropagation?.();

        this.abriuModalCategoriaEmMs = Date.now();

        // Copia props relevantes para observáveis locais
        runInAction(() => {
            this.categoriasSelecionadas = (this.props.minuta?.categorias && Array.isArray(this.props.minuta.categorias))
                ? this.props.minuta.categorias.slice()
                : [];
            this.categorias = (this.props.categoriasSelecionadas && Array.isArray(this.props.categoriasSelecionadas))
                ? this.props.categoriasSelecionadas.slice()
                : [];
            this.carregouCategorias = false;
        });

        this.setState({ modalCategoriaAberto: true, carregandoModalCategorias: true });

        void this.carregarDadosModalCategoria();
    };

    carregarDadosModalCategoria = async () => {
        try {
            await this.iniciarCategorias();

            if (this.idProcesso && this.tipoMinuta) {
                await this.esperarCarregamentoECarregarCatDeMinuta();
            }
        } catch (erro) {
            console.error('Erro ao abrir modal de categorias da minuta', erro);
        } finally {
            this.setState(prev => ({
                carregandoModalCategorias: false,
                versaoConteudoModal: prev.versaoConteudoModal + 1
            }));
        }
    };

    fecharModalCategoria = (_event?, reason?: string) => {
        if (reason === 'backdropClick' && Date.now() - this.abriuModalCategoriaEmMs < 250) {
            return;
        }
        this.setState({ modalCategoriaAberto: false, carregandoModalCategorias: false });
    };

    salvarCategorias = async () => {
        try {
            await CategoriaMinutaService.associarCategoriasAMinuta(this.props.processo as Processo, this.props.minuta, this.categoriasSelecionadas);
            await MovimentoService.recuperarMovimentosMinutas([this.props.processo as Processo], true);
            // await EscaninhoService.atualizarProcessos([this.props.processo as Processo])
            MovimentoCNJStore.quantidadeMovimentosIncluidos = 0;
            MovimentoCNJStore.quantidadeMovimentosRemovidos = 0;

            this.fecharModalCategoria();
        } catch (erro) {
            // A mensagem para o usuário já é exibida na camada de API (MensagemStore.apresentarErro).
            // Aqui apenas evitamos que a falha vire uma unhandled rejection e mantemos o modal aberto.
            console.error('Erro ao salvar categorias da minuta', erro);
        }
    }

    renderTransferListWithProps = (processo: Processo, minutasEmLote: boolean) => {
        return (
            <TransferList
                listToSelect={this.categorias}
                listSelected={this.categoriasSelecionadas}
                tituloListaParaSelecionar={'Categorias não adicionadas'}
                tituloListaJaSelecionados='Categorias selecionadas'
                campoDeDescricao='descricao'
                labelTooltip='categorias'
                setListToSelect={this.carregouCategorias}
                callbackSelect={this.selecionarCategorias}
                tooltipAcaoExtra='Complemento da categoria'
                acaoExtra={this.abrirModalComplementoCategoria}
                iconeAcaoExtra={(categoria: ICategoriaMinuta) => {
                    const precisaDeComplemento = processo?.ehPje && categoria.movimentoCNJ.filter(mov => mov?.variaveis?.length > 0);
                    if (precisaDeComplemento?.length > 0) {
                        return <ModalMovimentosCategoria categoria={categoria} processo={processo as Processo} emLote={minutasEmLote} />;
                    }
                    return <div></div>;
                }}
                condicaoParaAcaoExtra={(categoria: ICategoriaMinuta) => {
                    return categoria.codigoMovimentoCnj !== '0' && categoria.movimentoCNJ?.some((mov) => mov?.variaveis?.length > 0);
                }}
            />
        );
    }

    get categoriasDaMinuta() {
        return this.props.minuta.categorias || [];
    }

    render() {
        const processo = this.props.processo as Processo;
        const minutasEmLote = !!this.props.minutasEmLote;
        return (
            !this.props.minutasEmLote ?
                <>
                    <Tooltip
                        title={
                            <span data-testid="tooltip-categorias-minuta">
                                <p key="0">
                                    {'Categorias da Minuta' + (this.categoriasDaMinuta.length > 0 ? ': ' : '')}
                                </p>
                                <div style={{ width: '175px', maxHeight: '150px', overflow: 'auto' }}>
                                    {this.categoriasDaMinuta.map((cat, index) => {
                                        return (
                                            <p key={index} data-testid={`categoria-minuta-${index}`}>
                                                {cat.descricao}
                                            </p>
                                        );
                                    })}
                                </div>
                            </span>
                        }
                    >
                        <IconButton
                            component='span'
                            data-testid="botao-categoria"
                            onMouseDown={(ev) => {
                                ev.preventDefault();
                                ev.stopPropagation();
                                ev.nativeEvent?.stopImmediatePropagation?.();
                            }}
                            onClick={this.abrirModalCategoria}
                            color={this.categoriasDaMinuta.length > 0 ? 'primary' : 'default'}
                            aria-label='Abrir modal de categoria'
                        >
                            <Category data-testid="icone-categoria" />
                        </IconButton>
                    </Tooltip>

                    {this.state.modalCategoriaAberto &&
                        <Modal
                            aberto={this.state.modalCategoriaAberto}
                            fecharModal={this.fecharModalCategoria}
                            funcaoAcaoPrimaria={this.salvarCategorias}
                            labelAcaoPrimaria='Salvar'
                            funcaoAcaoSecundaria={this.fecharModalCategoria}
                            labelAcaoSecundaria='Cancelar'
                            titulo='Categoria de Minuta'
                            maxWidth='lg'
                            fullWidth
                            data-testid="modal-categoria-minuta"
                        >
                            {this.state.carregandoModalCategorias && this.categorias.length === 0 && this.categoriasSelecionadas.length === 0 ?
                                <div style={{ display: 'flex', justifyContent: 'center', padding: '24px' }}>
                                    <CircularProgress size={32} thickness={3} />
                                </div>
                                :
                                <div key={this.state.versaoConteudoModal}>
                                    <Observer>{() => this.renderTransferListWithProps(processo, minutasEmLote)}</Observer>
                                </div>
                            }
                        </Modal>
                    }
                </>
                :
                <>
                    <div data-testid="transfer-list">
                        <Observer>{() => this.renderTransferListWithProps(processo, minutasEmLote)}</Observer>
                    </div>

                    <Modal
                        aberto={this.modalComplementosAberto}
                        fecharModal={this.fecharModalComplementos}
                        funcaoAcaoSecundaria={this.fecharModalComplementos}
                        labelAcaoSecundaria='OK'
                        titulo='Complemento de Categoria'
                        maxWidth='md'
                        fullWidth
                        data-testid="modal-complemento-categoria"
                    >
                        <div
                            style={{ margin: 2, color: 'red' }}
                            data-testid="aviso-minuta-individual"
                        >
                            <b>
                                * Cada minuta deverá ser editada individualmente para ter a seleção e informação do complemento do movimento
                            </b>
                        </div>
                    </Modal>
                </>
        );
    }
}

export default observer(CategoriasMinuta);
